import { Button, SuccessIcon } from '@lokalise/louis'
import type { EvaluationMetrics } from '@lokalise/translation-api-schemas'
import { getNewEvaluationsUrl } from '../../../../utils/url'
import { EvaluationMetricsTable } from '../../../EvaluationMetricsTable/EvaluationMetricsTable'
import { StandaloneEvaluationMetricsTableWrapper } from '../../../EvaluationMetricsTable/StandaloneEvaluationMetricsTableWrapper/StandaloneEvaluationMetricsTableWrapper'
import { StepFooter, StepTitleContainer } from '../../../Step/Step'
import styles from './UpsellEvaluationStep.module.css'

type UpsellEvaluationStepProps = {
  profileId: string
  onClose: () => void
}

// Hard-coded data for display purposes only - this is an upsell preview, not a real evaluation.
const DUMMY_RESULTS: EvaluationMetrics = {
  perfectMatch: {
    evaluatedProfileResult: { value: 0.52, isBest: true },
    baseProfileResult: { value: 0.11, isBest: null },
    machineTranslationResult: { value: 0.08, isBest: null },
  },
  translationEditRate: {
    evaluatedProfileResult: { value: 0.22, isBest: true },
    baseProfileResult: { value: 0.54, isBest: null },
    machineTranslationResult: { value: 0.61, isBest: null },
  },
  bleu: {
    evaluatedProfileResult: { value: 0.78, isBest: true },
    baseProfileResult: { value: 0.44, isBest: null },
    machineTranslationResult: { value: 0.4, isBest: null },
  },
  chrf: {
    evaluatedProfileResult: { value: 0.85, isBest: true },
    baseProfileResult: { value: 0.61, isBest: null },
    machineTranslationResult: { value: 0.55, isBest: null },
  },
  meteor: null,
  aiScore: null,
  pastAiScore: null,
  engines: null,
}

export const UpsellEvaluationStep = ({ profileId, onClose }: UpsellEvaluationStepProps) => (
  <div className={styles.container}>
    <StepTitleContainer>
      <h2 className={styles.title}>Validate your profile</h2>
    </StepTitleContainer>
    <div className={styles.contents}>
      <div className="flex-col gap-1">
        <h2 className={styles.title}>Evaluate your translation quality</h2>
        <p className={styles.captionText}>
          See how your Custom profile performs right out of the box. Run a quick evaluation to
          understand its quality and start using it with confidence.
        </p>
      </div>
      <div className="flex gap-6">
        <div className="flex-col gap-1">
          <div className="flex gap-2 items-center">
            <SuccessIcon size="20px" color="var(--lok-color-text-link-default)" />
            <span className={styles.captionText}>Instant quality benchmark</span>
          </div>
          <div className="flex gap-2 items-center">
            <SuccessIcon size="20px" color="var(--lok-color-text-link-default)" />
            <span className={styles.captionText}>Trusted metrics</span>
          </div>
          <div className="flex gap-2 items-center">
            <SuccessIcon size="20px" color="var(--lok-color-text-link-default)" />
            <span className={styles.captionText}>Know before you scale</span>
          </div>
        </div>
        <div className={styles.tableContainer}>
          <div className={styles.tableInner}>
            <StandaloneEvaluationMetricsTableWrapper>
              <EvaluationMetricsTable
                profileName="Custom profile for Marketing"
                results={DUMMY_RESULTS}
              />
            </StandaloneEvaluationMetricsTableWrapper>
          </div>
        </div>
      </div>
    </div>
    <StepFooter>
      <Button variant="tertiary" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="primary" href={getNewEvaluationsUrl(profileId)}>
        Evaluate profile
      </Button>
    </StepFooter>
  </div>
)
